import { render } from "./ApplicationsList.vue?vue&type=template&id=ebcce20c"
import script from "./ApplicationsList.vue?vue&type=script&lang=js"
export * from "./ApplicationsList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__